import React from "react";
import {useTranslation} from "react-i18next";
import {Navigate, useNavigate, useParams} from "react-router-dom";

import Link from "@mui/material/Link";
import moment from "moment";

import {useGetSupportTicketQuery} from "../../../../../api/support";
import Preloader from "../../../../common/preloader";
import {COLORS} from "../../../../../config/constants";
import SupportPageLayout from "../../support-page-layout";
import {useSupportTicket} from "../../support-hooks";
import SupportPlanCard from "../plan-card";
import SupportRequestReplyForm from "./components/reply-form";
import SupportRequestThread from "./components/thread";

import './support-request-details-page.scss'

const SupportRequestDetailsPage = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const ticket = useSupportTicket();
  const {isError, isLoading, refetch} = useGetSupportTicketQuery(id || '', {
    refetchOnMountOrArgChange: true,
    skip: !id,
  });

  const request = ticket?.id === id ? ticket : undefined;

  if (!id || isError) {
    return <Navigate to='/cabinet/support' replace />;
  }

  if (isLoading || !request) {
    return (
      <SupportPageLayout hideCreateButton>
        <Preloader />
      </SupportPageLayout>
    );
  }

  const supportLevel = request.supportLevel || t('support__text__basicLevel');
  const requestDate = request.createdAt ? moment(request.createdAt).format('DD.MM.YYYY HH:mm:ss') : '';
  const calculationRow = request.calculationNumber ? [ {
    label: t('support__text__requestCalculation'),
    value: `№ ${request.calculationNumber}`,
  } ] : [];

  const handleMessageSent = async () => {
    await refetch();
  }

  const sidebar = (
    <SupportPlanCard
      title={`${t('support__text__requestTableId')} ${request.detailId || request.id}`}
      rows={[
        {
          label: t('support__text__level'),
          value: (
            <Link
              underline='none'
              className='support-request-details-page__level-link'
              sx={{color: COLORS.BLUE, cursor: 'pointer'}}
            >
              «
              <span className='support-request-details-page__level-name'>{supportLevel}</span>
              »
            </Link>
          ),
        },
        ...calculationRow,
        {
          label: t('support__text__requestDate'),
          value: requestDate,
        },
      ]}
    />
  );

  return (
    <SupportPageLayout
      headerTitle={`${t('support__text__requestSubject')}: ${request.subject}`}
      hideCreateButton
      onBackToSupport={() => navigate('/cabinet/support')}
      sidebar={sidebar}
    >
      <SupportRequestReplyForm
        ticketId={request.id}
        onCancel={() => navigate('/cabinet/support')}
        onSent={handleMessageSent}
      />
      <SupportRequestThread messages={request.messages || []} />
    </SupportPageLayout>
  );
};

export default SupportRequestDetailsPage;
